import { render, staticRenderFns } from "./MobilePublicity.vue?vue&type=template&id=debd1180&scoped=true&"
import script from "./MobilePublicity.vue?vue&type=script&lang=js&"
export * from "./MobilePublicity.vue?vue&type=script&lang=js&"
import style0 from "./MobilePublicity.vue?vue&type=style&index=0&id=debd1180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debd1180",
  null
  
)

export default component.exports